import {
  Activity,
  ArrowRight,
  BarChart3,
  BookOpen,
  Building2,
  CalendarCheck,
  Check,
  CircleHelp,
  ClipboardList,
  Download,
  Eye,
  FileText,
  Filter,
  Flag,
  GitCompare,
  ListOrdered,
  Lock,
  RefreshCw,
  Scale,
  Share2,
  SlidersHorizontal,
  Sparkles,
  Target,
  TrendingUp,
  Upload,
  Wallet,
  type LucideIcon,
} from 'lucide-react';

/** The icon names `helpContexts.json` may use in a guide action. */
export const GUIDE_ICONS: Record<string, LucideIcon> = {
  Activity,
  ArrowRight,
  BarChart3,
  BookOpen,
  Building2,
  CalendarCheck,
  Check,
  ClipboardList,
  Download,
  Eye,
  FileText,
  Filter,
  Flag,
  GitCompare,
  ListOrdered,
  Lock,
  RefreshCw,
  Scale,
  Share2,
  SlidersHorizontal,
  Sparkles,
  Target,
  TrendingUp,
  Upload,
  Wallet,
};

export const FALLBACK_GUIDE_ICON: LucideIcon = CircleHelp;
